<template>
  <div class="spotBox">
    <div class="left_spot" :style="{backgroundColor: left_backgroundColor, ...left_style}"></div>
    <div class="right_spot" :style="{backgroundColor: right_backgroundColor, ...right_style}"></div>
    <div class="title" :style="title_style">{{ title }}</div>
  </div>
</template>

<script>
export default {
  name: 'Spot',
  props: {
    title: {
      type: String,
      default: '',
    },
    left_backgroundColor: {
      type: String,
      default: '#ffDa21',
    },
    right_backgroundColor: {
      type: String,
      default: '#ED8468',
    },
    left_style: {
      type: Object,
      default: () => ({}),
    },
    right_style: {
      type: Object,
      default: () => ({}),
    },
    title_style: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {};
  },
};
</script>

<style scoped lang="less">
.spotBox {
  display: flex;
  flex-direction: row;
  align-items: center;
  .left_spot, .right_spot {
    width: 24px;
    height: 24px;
    z-index: 10;
    border-radius: 50%;
  }
  .right_spot {
    margin-left: -12px;
    z-index: 0;
  }
  .title {
    margin-left: 16px;
    font-weight: 600;
    color: #323232;
    font-size: 34px;
  }
}
</style>
